if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.sizeSelected = false;
        this.hasSizeOption = false;
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.productFormId = this.dataset.productFormId;
        this.button = this.querySelector('[data-sticky-atc-button]');
        this.textEl = this.querySelector('[data-sticky-atc-text]');

        this.moveToBody();
        document.addEventListener('shopify:section:load', () => this.moveToBody());

        this.init();
      }

      moveToBody() {
        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
        }
      }

      isMobile() {
        return window.matchMedia('(max-width: 749px)').matches;
      }

      getRoot() {
        return document.querySelector(`#MainProduct-${this.sectionId}`) || document;
      }

      getSizeInputs() {
        return Array.from(this.getRoot().querySelectorAll('[data-option-name="Size"]')).filter(
          (el) => el.tagName === 'INPUT' || el.tagName === 'OPTION'
        );
      }

      init() {
        const sizeInputs = this.getSizeInputs();
        this.hasSizeOption = sizeInputs.length > 0;

        this.realSubmitButton = document.querySelector(`#${this.productFormId} [type="submit"]`);
        this.realSubmitButtonText = this.realSubmitButton
          ? this.realSubmitButton.querySelector('span')
          : null;
        this.defaultSubmitText = this.realSubmitButtonText
          ? this.realSubmitButtonText.textContent
          : 'Add to Cart';

        this.paymentButtonWrap = document.querySelector(
          `#${this.productFormId} .shopify-payment-button`
        );

        // Desktop, or a product with no Size option: plain Add to Cart
        // everywhere. No gating, no text swap, nothing disabled.
        if (!this.isMobile() || !this.hasSizeOption) {
          this.setState('ready');
          this.button.addEventListener('click', () => this.submitForm());
          return;
        }

        // ---- Mobile + has a Size option: full "select a size first" gating ----
        this.sizeInputs = sizeInputs;
        this.sizeSelected = false;

        sizeInputs.forEach((el) => {
          if (el.tagName === 'INPUT') el.checked = false;
          if (el.tagName === 'OPTION') el.selected = false;
        });

        const select = this.getRoot().querySelector('select.select__select');
        if (select) select.selectedIndex = -1;

        this.sizeFieldset = sizeInputs[0].closest('fieldset, .product-form__input');

        const label = this.sizeFieldset && this.sizeFieldset.querySelector('[data-selected-value]');
        if (label) label.textContent = '';

        this.insertInlineError();

        // Hard-gate: physically hide the real Add to Cart button and the
        // dynamic checkout (Buy it now) button. Text-swap / overlay alone
        // isn't reliable because other scripts can still fire the real
        // click/submit directly.
        this.gateAddToCartButton(true);
        this.setupPaymentButtonGate(true);

        this.setState('select-size');

        this.getRoot().addEventListener('change', (event) => {
          if (event.target && event.target.matches('[data-option-name="Size"]')) {
            this.sizeSelected = true;
            this.hideSizeError();
            this.gateAddToCartButton(false);
            this.setupPaymentButtonGate(false);
            this.setState('ready');
          }
        });

        this.button.addEventListener('click', () => this.handleClick());
      }

      handleClick() {
        if (this.hasSizeOption && !this.sizeSelected) {
          this.scrollToSizePicker();
          return;
        }
        this.submitForm();
      }

      scrollToSizePicker() {
        if (!this.sizeFieldset) return;
        this.sizeFieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.sizeFieldset.classList.add('size-picker--pulse');
        setTimeout(() => this.sizeFieldset.classList.remove('size-picker--pulse'), 1200);
        this.showSizeError();
      }

      // ---- Real "Add to Cart" gating --------------------------------
      // Instead of trying to intercept clicks on the real submit button
      // (unreliable - other scripts/apps can still submit it directly),
      // we physically hide it and put a fake "Please select a size"
      // button in its place. Nothing can add to cart while gated because
      // the real button is not clickable/tappable at all.
      gateAddToCartButton(disable) {
        if (!this.realSubmitButton) return;

        if (disable) {
          if (!this.fakeAddToCartButton) {
            const fake = document.createElement('button');
            fake.type = 'button';
            fake.className = this.realSubmitButton.className;
            fake.setAttribute('data-fake-add-to-cart', '');
            fake.innerHTML = this.realSubmitButton.innerHTML;

            const fakeSpan = fake.querySelector('span');
            if (fakeSpan) fakeSpan.textContent = 'Add To Cart';

            fake.addEventListener('click', (event) => {
              event.preventDefault();
              this.scrollToSizePicker();
            });

            this.realSubmitButton.insertAdjacentElement('beforebegin', fake);
            this.fakeAddToCartButton = fake;
          }
          this.realSubmitButton.style.display = 'none';
          this.fakeAddToCartButton.style.display = '';
        } else {
          this.realSubmitButton.style.display = '';
          if (this.fakeAddToCartButton) {
            this.fakeAddToCartButton.style.display = 'none';
          }
        }
      }

     insertInlineError() {
  if (this.sizeErrorEl) return;

  // Target the span that wraps "Size:" + the data-selected-value span
  // (first child span of the legend), so the error sits right beside it.
  const labelHost =
    (this.sizeFieldset &&
      this.sizeFieldset.querySelector('.size-chart-legend > span')) ||
    this.sizeFieldset;

  if (!labelHost) return;

  const error = document.createElement('span');
  error.setAttribute('data-size-select-error', '');
  error.setAttribute('role', 'alert');
  error.className = 'size-select-error';
  error.textContent = 'Please select a size';
  labelHost.insertAdjacentElement('afterend', error);
  this.sizeErrorEl = error;
}

      showSizeError() {
        if (this.sizeErrorEl) this.sizeErrorEl.classList.add('is-visible');
      }

      hideSizeError() {
        if (this.sizeErrorEl) this.sizeErrorEl.classList.remove('is-visible');
      }

      // ---- "Buy it now" / dynamic checkout gating --------------------
      // Shopify loads the dynamic checkout button asynchronously and
      // REPLACES the inner HTML of .shopify-payment-button once it's
      // ready. If our overlay is appended INSIDE that wrapper it gets
      // wiped out the moment Shopify's script finishes loading - that's
      // why "Buy it now" kept working even though it looked disabled.
      // Fix: wrap the payment button in our own sibling container and
      // stack the overlay on top with CSS grid, so Shopify never touches
      // (and never deletes) our overlay element.
      setupPaymentButtonGate(disable) {
        if (!this.paymentButtonWrap) return;

        if (!this.paymentGateWrapper) {
          const wrapper = document.createElement('div');
          wrapper.className = 'size-gate-wrapper';
          this.paymentButtonWrap.parentNode.insertBefore(wrapper, this.paymentButtonWrap);
          wrapper.appendChild(this.paymentButtonWrap);
          this.paymentGateWrapper = wrapper;
        }

        if (disable) {
          this.paymentButtonWrap.classList.add('size-gate--disabled');
          if (!this.paymentOverlay) {
            this.paymentOverlay = document.createElement('div');
            this.paymentOverlay.className = 'size-gate-overlay';
            this.paymentOverlay.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
              this.scrollToSizePicker();
            });
            this.paymentGateWrapper.appendChild(this.paymentOverlay);
          }
        } else {
          this.paymentButtonWrap.classList.remove('size-gate--disabled');
          if (this.paymentOverlay) {
            this.paymentOverlay.remove();
            this.paymentOverlay = null;
          }
        }
      }

      submitForm() {
        if (!this.realSubmitButton || this.realSubmitButton.style.display === 'none') {
          return;
        }
        this.setState('adding');
        this.realSubmitButton.click();
        setTimeout(() => this.setState('ready'), 1200);
      }

      setState(state) {
        if (!this.button) return;
        this.button.dataset.state = state;
        if (state === 'select-size') this.textEl.textContent = 'Please select a size';
        else if (state === 'adding') this.textEl.textContent = 'Adding...';
        else this.textEl.textContent = 'Add to Cart';
      }
    }
  );
}